import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';
import { blueGrey, lightBlue } from '@material-ui/core/colors';

const styles = theme => ( {
    dot: {
        backgroundColor: blueGrey[100],
        borderRadius: '50%',
        display: 'inline-flex',
        height: 12,
        marginBottom: -2,
        marginRight: theme.spacing.unit / 2,
        width: 12,
    },
    legend: {
        display: 'block',
        textAlign: 'left'
    },
    legendText: {
        display: 'inline-block'
    },
    line: {
        background: lightBlue[600],
        display: 'inline-flex',
        height: 4,
        marginBottom: 2,
        marginRight: theme.spacing.unit / 2,
        width: 12,
    },
} );

const Legend = ( { legendItems, classes } ) => {
    return (
        <>
            {
                legendItems.map( ( legendItem, index ) => {
                    return (
                        <span key={index} className={classes.legend}>
                            {legendItem.iconType === 'dot' && <span className={classes.dot}/>}
                            {legendItem.iconType === 'line' && <span className={classes.line}/>}
                            <Typography variant="overline" color="textSecondary"
                                classes={{ root: classes.legendText }}
                            >
                                {legendItem.message}
                            </Typography>
                        </span>
                    );
                } )
            }
        </>
    );
};

Legend.propTypes = {
    classes: PropTypes.object.isRequired,
    legendItems: PropTypes.arrayOf(
        PropTypes.shape( {
            date: PropTypes.instanceOf( Date ),
            iconType: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
        } ),
    ),
};

Legend.defaultProps = {
    legendItems: [],
};

export default withStyles( styles )( Legend );
